import React, { CSSProperties, ReactElement } from 'react'
import { ButtonIconPosition, ButtonVariant } from '../button/style';
import clsx from 'clsx';

interface Props {
    label?: string;
    disabled?: boolean;
    icon?: ReactElement
    iconPosition: ButtonIconPosition
    variant: ButtonVariant
    onClick?: () => void
    fullWidth?: boolean
    iconSize?: number
}

export const buttonIconPositionMap = new Map<ButtonIconPosition, CSSProperties>([
    ['off', {}],
    ['only', {  }],
    ['left', { flexDirection: 'row' }],
    ['right', { flexDirection: 'row-reverse' }],
])

export function BillowButton(props: Props) {
    if (props.variant === 'outline')
        return (
            <button onClick={() => { props.onClick && props.onClick() }} className='min-w-[40px] bg-white hover:opacity-50 border border-[#6237fb] flex-grow px-6 py-3 flex flex-row items-center 
        justify-center gap-2 rounded-full opacity-100 cursor-pointer' title={props.label} disabled={props.disabled} >
                <span className=' text-text-md text-[#7C60FF]'>{props.label && props.label}</span>
            </button>
        )
    else
        return (
            <button style={{
                ...buttonIconPositionMap.get(props.iconPosition),
            }} onClick={() => { props.onClick && props.onClick() }} className={clsx(
                'min-w-[40px] bg-[#6237fb] hover:bg-[#7C60FF] border border-[#6237fb] flex-grow px-6 py-3 flex flex-row items-center justify-center gap-2 rounded-full opacity-100 cursor-pointer', {
                'opacity-40': props.disabled
            })}
                title={props.label} disabled={props.disabled} >
                {props.icon && React.cloneElement(props.icon)}
                {props.label && <span className=' text-text-md text-white'>{props.label}</span>}
            </button>

        )
}
